import Profile from '../pages/Profile';
import Authorization from '../pages/Authorization';
import PageNotFound from '../pages/PageNotFound';
import routeNames from '../util/routeNames';
import roles from '../util/roles';

const routes = [
  {
    path: routeNames.AUTH.PATH,
    name: routeNames.AUTH.NAME,
    component: Authorization
  },
  {
    path: routeNames.PROFILE.PATH,
    name: routeNames.PROFILE.NAME,
    component: Profile,
    meta: { requiresAuth: true }
  },
  {
    path: routeNames.ABOUT.PATH,
    name: routeNames.ABOUT.NAME,
    component: () => import(/* webpackChunkName: "bundle.about" */ '../pages/About'),
    meta: { hideHeader: true }
  },
  {
    path: routeNames.TERMSOFSERVICE.PATH,
    name: routeNames.TERMSOFSERVICE.NAME,
    component: () => import(/* webpackChunkName: "bundle.about" */ '../pages/TermsOfService'),
    meta: { hideHeader: true }
  },
  {
    path: routeNames.FAMILYLIST.PATH,
    name: routeNames.FAMILYLIST.NAME,
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: "bundle.familylist" */ '../pages/FamilyList'),
  },
  {
    path: routeNames.ADDFAMILY.PATH,
    name: routeNames.ADDFAMILY.NAME,
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: "bundle.addfamily" */ '../pages/AddFamily'),
  },
  {
    path: routeNames.ADMIN.PATH,
    name: routeNames.ADMIN.NAME,
    meta: { requiresAuth: true, role: roles.ADMIN },
    component: () => import(/* webpackChunkName: "bundle.admin" */ '../pages/admin/AdminDashboard'),
  },
  {
    path: routeNames.ADMINORGS.PATH,
    name: routeNames.ADMINORGS.NAME,
    meta: { requiresAuth: true, role: roles.ADMIN },
    component: () => import(/* webpackChunkName: "bundle.admin" */ '../pages/admin/AdminOrganizations'),
  },
  {
    path: routeNames.ADMINUSERS.PATH,
    name: routeNames.ADMINUSERS.NAME,
    meta: { requiresAuth: true, role: roles.ADMIN },
    component: () => import(/* webpackChunkName: "bundle.admin" */ '../pages/admin/AdminUsers'),
  },
  {
    path: routeNames.ADMINUSERSBYORG.PATH,
    name: routeNames.ADMINUSERSBYORG.NAME,
    meta: { requiresAuth: true, role: roles.ADMIN },
    component: () => import(/* webpackChunkName: "bundle.admin" */ '../pages/admin/AdminUsers'),
  },
  {
    path: routeNames.ADMINDUPLICATES.PATH,
    name: routeNames.ADMINDUPLICATES.NAME,
    meta: { requiresAuth: true, role: roles.ADMIN },
    component: () => import(/* webpackChunkName: "bundle.admin" */ '../pages/admin/AdminDuplicates'),
  },
  // {
  //   path: '/index.html',
  //   redirect: '/'
  // },
  {
    path: '*',
    component: PageNotFound,
    meta: { hideHeader: true }
  },
];

export default routes;
